<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <graph-tool-bar :showSource="false" @on-selected="onPanelSelect" :dateRangeMenu="false"></graph-tool-bar>
      <br />
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-warning">
          <div class="card-icon">
            <md-icon>list</md-icon>
          </div>
          <h4 class="title">Meters list</h4>
        </md-card-header>

        <md-card-content>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
            v-if="metersData.length"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">{{$lang.inputs.number_of_rows}}</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >{{ item }}</md-option>
                </md-select>
              </md-field>

              <md-field>
                <label>{{$lang.inputs.search}}</label>
                <md-input
                  type="search"
                  class="mb-2"
                  clearable
                  style="max-width: 200px"
                  placeholder="Search meter"
                  v-model="searchQuery"
                ></md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                v-for="cell in tableCells"
                :key="cell.key"
                :md-label="cell.name"
                :md-sort-by="cell.short ? cell.key : null"
              >
                <span
                  v-if="cell.key != 'MTIME'"
                  v-show="!item[cell.key].edit"
                  @dblclick="showInput(item[cell.key], cell.key)"
                  style="cursor: pointer;"
                >{{ item[cell.key].value }}</span>

                <span v-else>{{ item[cell.key].value }}</span>

                <md-field
                  v-if="cell.key != 'MTIME'"
                  v-show="item[cell.key].edit"
                  @dblclick.native="item[cell.key].edit = false"
                >
                  <label>Edit</label>
                  <md-input
                    v-on:keyup.enter="submitEdited(item[cell.key], item)"
                    :ref="cell.key"
                    v-model="item[cell.key].value"
                  ></md-input>
                </md-field>
              </md-table-cell>

              <md-table-cell md-label="Actions">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  title="Delete"
                  @click="deleteMeter(item.ID_meter.value)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <div v-if="!metersData.length">
            <md-empty-state
              md-icon="filter_none"
              md-label="Any stored meters"
              md-description="No stored meters in database"
            ></md-empty-state>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class>
            <p
              class="card-category"
            >{{$lang.general.showing}} {{ from + 1 }} - {{ to }} {{$lang.general.of}} {{ total }} {{$lang.general.rows}}</p>
          </div>

          <div>
            <md-button
              class="md-warning"
              @click.native="downloadMeters"
              :disabled="!getStatus()"
            >Download database from device</md-button>

            <md-button
              class="md-danger"
              @click.native="uploadMeters"
              :disabled="!getStatus()"
            >Update database in device</md-button>
          </div>

          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";
import format from "date-fns/format";

import axios from "axios";
import Swal from "sweetalert2";

import { Pagination } from "@/components";
import Fuse from "fuse.js";

export default {
  components: {
    graphToolBar,
    snackBar,
    Pagination
  },

  data() {
    return {
      selected: {
        device: {}
      },
      metersData: [],
      tableCells: [
        {
          name: "IDN",
          key: "IDN",
          short: true
        },
        {
          name: "CRC",
          key: "CRC",
          short: false
        },
        {
          name: "Serial number",
          key: "SNUM",
          short: true
        },
        {
          name: "Type",
          key: "TYPE",
          short: true
        },
        {
          name: "LP Count",
          key: "LPCOUNT",
          short: true
        },
        {
          name: "Time",
          key: "MTIME"
        },
        {
          name: "Manufacturer",
          key: "PRODUCER",
          short: true
        },
        {
          name: "Year",
          key: "YMAN",
          short: true
        },
        {
          name: "Voltage ratings",
          key: "VOLTAGE"
        },
        {
          name: "Current ratings",
          key: "CURRENT"
        },
        {
          name: "Constant",
          key: "CONSTANT"
        },
        {
          name: "Constant unit",
          key: "CONSTUNIT"
        },
        {
          name: "Scalefactor",
          key: "SCALEFACTOR"
        },
        {
          name: "Accuracy class",
          key: "CLASS",
          short: true
        },
        {
          name: "Energy type",
          key: "MENERGYTYPE"
        },
        {
          name: "Frequency",
          key: "FREQ"
        },
        {
          name: "Connection type",
          key: "CONTYPE"
        },
        {
          name: "Customer",
          key: "CUSTOMER",
          short: true
        },
        {
          name: "Area",
          key: "AREA"
        },
        {
          name: "Location",
          key: "LOCATION",
          short: true
        },
        {
          name: "Address",
          key: "ADDRESS",
          short: true
        },
        {
          name: "CT Ratio",
          key: "CTRATIO"
        },
        {
          name: "VT Ratio",
          key: "VTRATIO"
        },
        {
          name: "Note 1",
          key: "NOTE1"
        },
        {
          name: "Note 2",
          key: "NOTE2"
        },
        {
          name: "Note 3",
          key: "NOTE3"
        },
        {
          name: "Note 4",
          key: "NOTE4"
        },
        {
          name: "Measurement type",
          key: "ELM_OUTPUT_TYPE"
        },
        {
          name: "IMIN",
          key: "IMIN"
        },
        {
          name: "INOM",
          key: "INOM"
        },
        {
          name: "IMAX",
          key: "IMAX"
        },
        {
          name: "UNOM",
          key: "UNOM"
        },
        {
          name: "SQRT3",
          key: "SQRT3"
        },
        {
          name: "Constant type",
          key: "CONSTTYPE"
        },
        {
          name: "ISIDE",
          key: "ISIDE"
        },
        {
          name: "USIDE",
          key: "USIDE"
        },
        {
          name: "DIALREG",
          key: "DIALREG"
        },
        {
          name: "Energy method",
          key: "ENERMETHOD"
        },
        {
          name: "CT Snom",
          key: "CTSNOM"
        },
        {
          name: "VT Snom",
          key: "VTSNOM"
        }
      ],
      currentSort: "IDN",
      currentSortOrder: "desc",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25],
        total: 0
      },
      searchQuery: "",
      searchedData: [],
      fuseSearch: null
    };
  },

  computed: {
    deviceList() {
      return this.$store.getters.getDeviceList;
    },
    queriedData() {
      let result = this.metersData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.metersData.length;
    }
  },

  watch: {
    searchQuery(value) {
      let result = this.metersData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  },

  created() {
    this.$store.commit("setLoading", true);
  },

  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return String(a[sortBy].value).localeCompare(String(b[sortBy].value));
        }
        return String(b[sortBy].value).localeCompare(String(a[sortBy].value));
      });
    },

    onPanelSelect(data) {
      this.selected = data;
      this.getMeters();
    },

    formatDateTime(ts) {
      return format(ts * 1000, "DD.MM.YYYY HH:mm:ss");
    },

    getStatus() {
      try {
        if (
          this.deviceList[
            this.deviceList.findIndex(e => e.mac == this.selected.device.mac)
          ].status == "ONLINE"
        ) {
          return 1;
        } else {
          return 0;
        }
      } catch (err) {
        return 0;
      }
    },

    submitEdited(item, object) {
      item.edit = false;

      let meter = {};
      Object.keys(object).forEach(key => {
        if (key == "MTIME") {
          meter[key] = object[key].ts;
        } else {
          if (object[key].value == "-") {
            meter[key] = "";
          } else {
            meter[key] = object[key].value;
          }
        }
      });

      delete meter.ID_meter;

      axios({
        method: "PUT",
        url: this.$ENDPOINTS.API_W + "/applied-precision/meters",
        data: {
          device_token: getSelectedDeviceToken(this.selected.device.mac),
          ID_meter: object.ID_meter.value,
          meter: meter
        },
        withCredentials: true
      })
        .then(response => {
          this.$refs.snackbar.notify("Database successfully updated");
        })
        .catch(error => {
          this.$refs.snackbar.notify("Failed database update");
          console.log(error);
        });
    },

    showInput(item, key) {
      item.edit = true;
      this.$nextTick(() => {
        this.$refs[key][0].$el.focus();
      });
    },

    getMeters() {
      this.$store.commit("setLoading", true);
      this.metersData = [];

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/applied-precision/meters",
        data: {
          device_token: getSelectedDeviceToken(this.selected.device.mac)
        },
        withCredentials: true
      })
        .then(response => {
          //this.metersData = response.data.data;
          //delete this.tableCells.ID_meter;
          //this.tableCells = Object.keys(response.data.data[0]);

          for (const element of response.data.data) {
            const objArray = Object.keys(element);
            let newPush = {};

            objArray.forEach(key => {
              newPush[key] = {
                value: element[key].length != 0 ? element[key] : "-",
                edit: false
              };
              if (key == "MTIME") {
                newPush[key].value = this.formatDateTime(element[key]);
                newPush[key].ts = element[key];
              }
            });

            this.metersData.push(newPush);
          }

          this.fuseSearch = new Fuse(this.metersData, {
            keys: [
              "SNUM.value",
              "TYPE.value",
              "PRODUCER.value",
              "YMAN.value",
              "LOCATION.value"
            ],
            threshold: 0.3
          });

          this.$store.commit("setLoading", false);
        })
        .catch(error => {
          this.$store.commit("setLoading", false);
          if (error.response) {
            if (error.response.data.code === 610) {
              this.metersData = [];
            }
          }
        });
    },

    deleteMeter(ID_meter) {
      axios({
        method: "DELETE",
        url: this.$ENDPOINTS.API_W + "/applied-precision/meters",
        data: {
          device_token: getSelectedDeviceToken(this.selected.device.mac),
          ID_meter: ID_meter
        },
        withCredentials: true
      })
        .then(response => {
          this.getMeters();
        })
        .catch(error => {
          console.log(error);
        });
    },

    downloadMeters() {
      Swal.queue([
        {
          title: this.$lang.general.are_you_sure,
          text: "Lokálna databáza bude nahradená databázov zariadenia",
          type: "warning",
          showCancelButton: true,
          cancelButtonClass: "md-button md-danger",
          cancelButtonText: this.$lang.keys.cancel,
          confirmButtonClass: "md-button md-success",
          confirmButtonText: this.$lang.keys.yes,
          buttonsStyling: false,
          showLoaderOnConfirm: true,

          preConfirm: () => {
            Swal.insertQueueStep({
              title: "Downloading...",
              text: "Please wait",
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false
            });

            axios({
              method: "POST",
              url:
                this.$ENDPOINTS.API_W + "/applied-precision/download-database",
              data: {
                device_token: getSelectedDeviceToken(this.selected.device.mac),
                meters: true
              },
              withCredentials: true
            })
              .then(response => {
                Swal.fire({
                  title: this.$lang.messages.success,
                  text: "Successfully downloaded meters database",
                  type: "success",
                  confirmButtonClass: "md-button md-success",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false,
                  timer: 2000
                }).then(() => {
                  this.$nextTick(() => {
                    this.getMeters();
                  });
                });
              })
              .catch(error => {
                //Swal.close();
                Swal.fire({
                  title: this.$lang.messages.error,
                  text: this.$lang.messages.api_communication_error,
                  type: "error",
                  confirmButtonClass: "md-button md-warning",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false
                });
              });
          }
        }
      ]);
    },

    uploadMeters() {
      Swal.queue([
        {
          title: this.$lang.general.are_you_sure,
          text: "Databáza zariadenia bude nahradená lokálnou databázou",
          type: "warning",
          showCancelButton: true,
          cancelButtonClass: "md-button md-danger",
          cancelButtonText: this.$lang.keys.cancel,
          confirmButtonClass: "md-button md-success",
          confirmButtonText: this.$lang.keys.yes,
          buttonsStyling: false,
          showLoaderOnConfirm: true,

          preConfirm: () => {
            Swal.insertQueueStep({
              title: "Uploading...",
              text: "Please wait",
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false
            });

            axios({
              method: "POST",
              url: this.$ENDPOINTS.API_W + "/applied-precision/upload-database",
              data: {
                device_token: getSelectedDeviceToken(this.selected.device.mac),
                meters: true
              },
              withCredentials: true
            })
              .then(response => {
                Swal.fire({
                  title: this.$lang.messages.success,
                  text: "Successfully uploaded meters database",
                  type: "success",
                  confirmButtonClass: "md-button md-success",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false,
                  timer: 2000
                })
              })
              .catch(error => {
                //Swal.close();
                Swal.fire({
                  title: this.$lang.messages.error,
                  text: this.$lang.messages.api_communication_error,
                  type: "error",
                  confirmButtonClass: "md-button md-warning",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false
                });
              });
          }
        }
      ]);
    }
  }
};
</script>


<style lang="scss" scoped>
.md-toolbar {
  position: inherit;
}
</style>
